import { LoadingContainer, LegacyPage, Model } from 'peach/components'
import { useParams, useRouteMatch, useHistory } from 'peach/router'
import { useClickAction } from 'peach/decorators/withActionTrigger'

import { useInternalCompanyApiKeysGetAll } from 'core/types/generated/api-keys/hooks'

const APIKeys = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()

  const { data: apiKeys, isLoading } = useInternalCompanyApiKeysGetAll({
    companyId,
    query: {
      status: 'active',
      limit: 100,
    },
  })

  useClickAction({
    label: 'Create API Key',
    onClick: () => history.push(`${url}/create`),
  })

  return (
    <LoadingContainer isLoading={isLoading}>
      <LegacyPage.Full>
        <Model.List
          json={apiKeys}
          title='API Keys'
          withDetails
          withRelated
          withTimestamps
        />
      </LegacyPage.Full>
    </LoadingContainer>
  )
}

export default APIKeys
